import React from 'react';

import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, Col, Row } from 'reactstrap';
import FormikField from '@/components/FormikField';
import useFaq from '@/hooks/useFaq';
import { errorAlert, successAlert } from '@/helpers/alerts';

interface Props {
  onCreated: () => void;
}
// 1920 Senior Software Engineer
const CreateForm: React.FC<Props> = ({ onCreated }) => {
  const { createFaq } = useFaq();
  const initialValues = {
    question: '',
    answer: '',
  };
  const formik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      question: Yup.string().required('Intrebarea este obligatorie'),
      answer: Yup.string().required('Raspunsul este obligatoriu'),
    }),
    onSubmit: (values) => {
      createFaq(values)
        .then(() => {
          onCreated();
          successAlert('Intrebare creata cu succes');
        })
        .catch((error) => {
          errorAlert(error.message);
        });
    },
  });

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <FormikField
            formik={formik}
            label="Intrebare"
            name="question"
            type="text"
          />
        </Col>
        <Col lg={12}>
          <FormikField
            formik={formik}
            label="Raspuns"
            name="answer"
            type="textarea"
          />
        </Col>
        <Col lg={12}>
          <Button
            color="primary"
            type="submit"
            onClick={() => {
              formik.handleSubmit();
            }}
          >
            Creaza
          </Button>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default CreateForm;
